"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportTicketsService = void 0;
class SupportTicketsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Calculate Missing Events Tickets Counts
     * @param date
     * @returns any Successful response
     * @throws ApiError
     */
    calculateMissingEventsTickets(date) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/support-tickets/missing-events/calculate',
            query: {
                'date': date,
            },
        });
    }
}
exports.SupportTicketsService = SupportTicketsService;
